"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicViewWorkStore = void 0;
const mobx_1 = require("mobx");
const workAPI = __importStar(require("@App/api/routes/work"));
const work_store_1 = require("@App/stores/work/work-store");
const navigation_1 = __importDefault(require("@App/navigation"));
class PublicViewWorkStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_viewWorkPublic", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this, {
            _viewWorkPublic: mobx_1.observable,
            setViewWorkPublic: mobx_1.action,
            resetViewWorkPublic: mobx_1.action,
        });
        this.rootStore = rootStore;
    }
    get viewWorkPublic() {
        return this._viewWorkPublic;
    }
    setViewWorkPublic(viewWorkPublic) {
        this._viewWorkPublic = viewWorkPublic;
    }
    resetViewWorkPublic() {
        this._viewWorkPublic = undefined;
    }
    getWorkCatalogById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            this.rootStore.preloaderStore.openMainPreloader(true);
            try {
                const response = yield workAPI.getWorkCatalogById(id);
                if (!response) {
                    return;
                }
                const workWithLocalId = work_store_1.WorkStore.mapResponseToWorkObject(response.data);
                this.setViewWorkPublic(workWithLocalId);
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
            finally {
                if (!this.viewWorkPublic) {
                    this.rootStore.popupStore.setAlertData('Could Not Find Work', true);
                    (_a = this.rootStore.router) === null || _a === void 0 ? void 0 : _a.navigate(navigation_1.default.search.root());
                }
            }
            this.rootStore.preloaderStore.openMainPreloader(false);
        });
    }
}
exports.PublicViewWorkStore = PublicViewWorkStore;
